import React, { Component } from "react";
import Group from "../assets/v2//images/Group.png";
import finance from "../assets/v2/images/finance.svg";
import supplychain from "../assets/v2/images/supplychain.svg";
import retail from "../assets/v2/images/retail.svg";
import agricultureicon from "../assets/v2/images/agricultureicon.svg";
import Educationicon from "../assets/v2/images/Educationicon.svg";
import Governanceicon from "../assets/v2/images/Governanceicon.svg";
import healthcareicon from "../assets/v2/images/healthcareicon.svg";


export class Implemetation extends Component {

  render() {
    return (
      <section>
        <div class="hero_sec">
          <div class="container">
            <div class="row no-gutters align-items-center">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 ">
                <div class="detail">
                  <h1 style={{ marginTop: "100px" }}>
                    Industry Uses and{" "}
                    <p
                      class="mt-4"
                      style={{ fontSize: "45px", color: "#024AAD" }}
                    >
                      Portfolio.
                    </p>
                  </h1>
                  <p>
                    Shubh is being built to accommodate a broad range of use
                    cases, solving problems across multiple industry verticals.
                  </p>
                  {/* <a href="#" class="btns">Get started</a>  */}
                  <div class="clearfix"></div>
                  {/* <a href="#intentSection" class="scroll_down"><img src="images/long_arrow_down.svg" alt=""></a> */}
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                <img src={Group} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="built_sec">
          <div class="container">
            {/* <h2 class="global_title">Built for the next generation <br>of business <span>challenges</span>.</h2>  */}
            <div class="row specing17">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <div class="built_block">
                  <figure>
                    <img src={finance} alt="" />
                  </figure>
                  <div class="detail">
                    <h3>Finance</h3>
                    <p>
                      Using blockchain to deliver a one-click user experience
                      and accelerate onboarding through the utilization of
                      reusable verified credentials.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <div class="built_block">
                  <figure>
                    <img src={agricultureicon} alt="" />
                  </figure>
                  <div class="detail">
                    <h3>Agricultural</h3>
                    <p>
                      Maintaining a steady flow of produce with product
                      certification and traceability, from farm to table.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <div class="built_block">
                  <figure>
                    <img src={supplychain} alt="" />
                  </figure>
                  <div class="detail">
                    <h3>Supply chain</h3>
                    <p>
                      Enabling faster and more cost-efficient delivery of
                      products, enhancing products’ traceability, improving
                      coordination between partners.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <div class="built_block">
                  <figure>
                    <img src={Educationicon} alt="" />
                  </figure>
                  <div class="detail">
                    <h3>Education</h3>
                    <p>
                      Securing academic certifications within an ecosystem, and
                      empowering institutions to instantly verify those
                      credentials.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <div class="built_block">
                  <figure>
                    <img src={Governanceicon} alt="" />
                  </figure>
                  <div class="detail">
                    <h3>Governance</h3>
                    <p>
                      Simplifying document verification and processing for
                      improved monitoring and authentication of official
                      records.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                <div class="built_block">
                  <figure>
                    <img src={retail} alt="" />
                  </figure>
                  <div class="detail">
                    <h3>Retail</h3>
                    <p>
                      Anti-counterfeiting initiatives to establish product
                      auditability to ensure every product sold is certified
                      original.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
              <div class="built_block">
                <figure>
                  <img src={healthcareicon} alt="" />
                </figure>
                <div class="detail">
                  <h3>Healthcare</h3>
                  <p>
                    Verification of the origin and supply of pharmaceutical
                    products, guaranteeing the safety and well-being of patients
                    worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Implemetation;
